<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <v-combobox
        item-value="key"
        item-text="value"
        :items="items"
        :value="current"
        :error-messages="errors"
        :label="label"
        :readonly="readonly"
        :clearable="clearable && !readonly"
        :prepend-icon="prependIcon"
        return-object
        eager
        :dense="dense"
        @change="change"
        @contextmenu.prevent>
      <template v-slot:prepend-inner>
        <v-icon
            v-if="required"
            small
            left
            :color="requiredColor">
          *
        </v-icon>
      </template>
    </v-combobox>
  </ValidationProvider>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: null
      },
      rules: [String, Object],
      prependIcon: {
        type: String,
        default: ''
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      valuesEnum: {
        type: Object,
        default: () => { return {} }
      },
      dense: {
        type: Boolean,
        default: false
      },
      vid: {
        type: String,
        default: null
      }
    },
    // data () {
    //   return { current: null }
    // },
    computed: {
      items () {
        return Object.keys(this.valuesEnum)
          .map(key => ({ key, value: this.$t(this.valuesEnum[key]) }))
      },
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') &&
            !!this.rules.length &&
            this.rules.includes('required'))
      },
      current () {
        if (this.value) {
          return this.items.find(i => i.key === this.value) || null
        }

        return null
      }
    },
    methods: {
      change: function (item) {
        this.$emit('input', item && item.key
          ? item.key
          : null)
        this.$emit('change', item && item.key
          ? item.key
          : null)
      }
    }
  }
</script>
